import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
  withRouter,
  useHistory,  // Acces to history object
  useParams,  // Get url params
} from 'react-router-dom';

import axios from 'axios';
import { loadingPrincipal } from '../../../functions';

import Footer from '../footer';
import Header from '../header';

import NuevasOportunidades from '../../partials/nuevas-oportunidades';
import Noticias from '../../partials/noticias';
import Calendario from '../../partials/calendario';
import CompartidoOtros from '../../partials/compartido-otros';
import Compartir from '../../partials/compartir';
import AnalisisMercado from '../../partials/analisis-mercado';
import Consultorio from '../../partials/consultorio';
import VistoRedes from '../../partials/redes';
import UltimosSucesos from '../../partials/ultimos-sucesos';
import OtrosSectores from '../../partials/otros-sectores';
import NoticiasOcex from '../../partials/noticiasOcex';

import {API_URL,BASE_URL_RECURSOS} from '../../../constants';
import NotFound from '../../../not-found';
import Unsubscribe from '../../extras/unsubscribe';

import ResourceDetail from '../../bulletin/recurso';
import Principal from '../../bulletin/principal';

import Moment from 'moment';
import Listado from '../../bulletin/listado';

const logoFacebook = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABBtJREFUWAnFV0trU0EUnpncJG18YaxigwGtdVPBhVjopqALERRfm1JwoyD+AJcqXQhuRLpw6UJBKPhYaAXXLlz4AheKukhqm6akUprgq20eTY7fdy+33JjXbRtxIJk7M+d83znzOHNGK59FRELJdO6IqsgprVQf1GKiVDfV0Z5FlUH7szL6WW88+kJrXeRYqwLd5mVy7vfO5cX8CGjOKSWbvdJQzrMN4g5vP2R/onfMinRc37Nj47fqsepWQwPgcXginbuK+jIYNgC0qLWiZ+MgfBnWgUw8viVHuHT6R7Qg5RjABisiZyB/GAaEMDULkB/dG4/eQF2opnZadQ1wvC48AcgAiEvGyB0Jha/37tw0Vw/k777kt187dLEwUqnoS8AIAuO1FQmfrTcbNQZ8TecOlCvyXInsgsfvtQkO741vSfxN4qc9kf6xTyqlByLqoNJ6xhh9HLPx0atbZYDt+VLhHcmh8HhDMHo+FtOLXoXVfmcyElks5e5hKYdohNUZ7q83E+CUcGIq+yoxNS+JVPYR2lXGrZbYK0+sZCr70MYGB7ncceN+cMNxzTnt9BybBnutPYVYkWD0ArHJ4XA52LaXztTnk0p0yASs/atdc3o0O6sC3d2qBLJSI7O5Jyrl5U9KS9Hq7OjlUtgzYJ9zHDXudr/kqdT3rViyu5jWOUxvfqGYXUhO5641Imc/scnBY+3EFqUMrA/hmCDI6CKPWjMA71hJlW9iOi+gb7u3v9W3w8Eoqc+R29jhFRGOQcbvObdJRB11ybQ29wNKXwxa5qnb16gmB7lg/GZyW4ztFMbajTdSqtuvZTtjMIs26lZPfFvV+XZG6v+TC94fI7eFXdhHHPxe1hev7p2cyQ6Uy9KPk4UI51ggZTWcTM0fNka96Yl3va3WqG25XOTmJoxRhLG9VrS2p7ysTyKy3QY5DHCKqMoV9omYQ25fs9rDFTMIN7xE8u7F0kyx5Zio6ZYyECAXOW3uRGr+F0KO1bu7q9OPsiuDKV+A1xG2gyHVtzvW9cUd81Mnp+aXYMCyATkTiQ5eqX4U2yFDLnKSm3vAXnve5+0A94Ph4coYWPKZSliTQT/K7ZBxuchtmMMRFOfydDvA/WCscIHbMIGE/z+xoY4wk/EDsB4ZcpCLnOQ2iEqIyzKGX4hp1HrA/eg6HLx/ZIzcWA6l1nIdp9PSGcAFQH1cw0sAw5I2Lw2vY97LABiFVUHmcEyjmkMxmOglpmv8+SEnJrHJQa6atAwbYyUlY/qEtu1dK0P8jBOrZUoGqwpMnZk4QmFoYjrnayZaGUDPiUVMOykFB7lcvRov/2VaHjD6RE88+sElZ11jADv/68OEBrBgytb0NIPeaeecr+Np5pjg/Duz8R8ep14j+A3Pap/nyCU4xlsN1Zqe538A/mdnZ2RLIH4AAAAASUVORK5CYII=`;
const logoLinkedin = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABC1JREFUWAnFV82LFFcQr3rzta6uiy2IGTKauOtFQTAgmMNC9KgkJhAkxEsCiX9AbiJ4EISQgxAIHrx4EhINBIUcQw4RDAgeNHrZWePumIno7ATXZHdm1uny9+u2x/no2R7XCftgpvu9+vhV1atXr1plwGFm2WKpekB8+0BFdkEsbyJvUBzzv/EoY35XnF6dLHi/qmqDtKQB2ZXHn4/+3fpssXYKMMdEbGM7N4RrnAN4pH0dvAtYvZgeHTn99pYNDztpnbO+BsDj3EypehLPr4CwHkobqkLPrgDwt5ymyoXCeJXqSqUnXt2aeSib8s0+BP97MCCL0PwH/rMTBe8MnvVO6HAWa0Dodf0nKNkP4GXn7Lxlc6cnt449ilPSvVZ8+HSLNuqnfF+PQ0cGOn5Pj+Y+iotGjwH3StU9Td9+FrM34fFNdZlPJgrj090gg8xnSk92mr/8vZm8I6oPnNNDiMbtdtkOAwLPl+o3CA6By+sz3mf5vC62C7zqe7lso4vL1QvYyqM0Ir0uty8uEsC03PT9+evT9ys2PTt/CfMO414VuJ2fuoqz8z8EuoFBrIjuohcmHPecYafnSBrk2nAGdY1mvM+pmxghVqg78DIMfa0oplmXSu9e7Z4nmcuc8JvP7ohaI71uZJJbEUQgOOc4asz2fuDF2epxbE2lOFv55fFjG0sCi6NTNzF4rMPaIuKwH1kcExQZbfCoxQkGa2bfIFE2I6MPLixVP+7Ll0AIMVgl9RixXVBeUeFYZFY85yq3qDvMjfQfCTh9ycQgFnJhI7Eda/sLxVf6SoGgY/o+/r9MOXt3Ytv4jZV4k2hwIsQCdhpZuIvpzvK6kqA9tW/Bu7fZVEEufKpiB5G0XwQyqhdN7DDW9mH+QMX9uGPbppNhtHq1RljEToOcJwtrey9r+4rthuAerjhxm5AL2wEazJEbwZOOYOw08U/cm/sHF5J8Hax0/RGrJj5X8w7lhpdILbpYungHnsLba0iQvyIBGIfEjh/EIiaxW4UonnWwVYBfmty+eUosFeQTpWDAW4NIO9Q7NhIjvFIHEYjjgTd3uO6NNYstusmG1nvXC7GISWxGINh73uddfANPfbFlMnueFzQoSYJtWGUHS+5SAF5MJQkOix5hERsJrVepGFXpyLAAkvS0sIDt2EDC/wUcqwPsZPoL6xKSrcmfaArtldZezlvtFu/wF+uyFKeLGMQiZogNLtzT53hXz8xVvosTGuYaMcK+oHKOemGwyJpfx7yXEc6zyIQMezi2UTRsmIM6qZsYxOppy5AYrZaM7RPmQXSGYQR1JbZksKrO1pmNIwSOzsxVhxIJek5d1EndxCBW5FiPl/9nW55yenhHwQv6ir4GkLCmHyaRZQjZqj7NIHckPOev8WkWGfEyGmvwcdpuBN/hWe/nOe5z0nir4bGqz/Pn0tJqmMItXNIAAAAASUVORK5CYII=`;
const logoYoutube = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABFhJREFUWAnFVz1sHFUQfrO79+OLQ6IzWOHkwyK+UICUIlIEBZGShlggCDQBKRRQQEEVpYsQKSJRoEhpKJDSpDK/BXIkpCAKhFKAQKIAkebOJPZFhxXiVQzEuTvf7vB9u95k73bPZ58T+RX39r2Z+b6ZefN+TswGm6pma3X3iPH1FTHmaZiV1JjHaY7xX+gaGF81llyqlIvfi0ibskENtuu3azf/29NZaZ4BzQlj9JG4NoybHIM4H5+H7j+YnXEK+bNPjo8udsu6R30dQMS5ubr7PvpTYNgB0LaIYWSzILySE7tRLu9yCVevLxdb6pUAdshXfRX6h+FAFqm5A/3zU+Xih+hb3dThKNWBMOrW1wB5DsSrlqUXNJs7W9mz82YaSO9cbfHfcWm3zvi+vAuMDDB+cgq519KykXDgz7q73/P1G6M6gYh/FSvzxlR5V7WXZCPjufryPvVXP1c1B4zIDcuSF5GN3+O2XQ4Ekd9t/UJyGHy1I1N8q1SSlbjBZr8bDS2srLoXsZTH6YQzkjuYlglwaq56fenH6vVbWp1f+hLjLuc2SxzXJ1ZtfumLABsc5IrkVvTBguOaM+2MHEWDWnswjViFTPFtYpMj5AqxgyjD1DdrRiVr2c4zw675IHdZE77X+cOItp2RfIVLEWQg2OfYaqz2h0VO54hNDm7r8GwxxsJ6ZLFNcMhIm1ttUBRblYccPCXlBLmlurB0FMfrZazTt5XJsek0glp9uWK8zkc4WA7CaDfW0k7Tw3bzgHNbjf4wYsvpiYmxG2l6KMjLwDmKY3va4dlOJRjOpikHc17nY4BO88xlA1HfBuCdEL5519Pd6F9OUyRX4AC4LVQhLxZiX0lTDmSiz/fKALKOGwhI5VCvTTSOuMjNIixRwLM9UujtxUihdw4un7Rt8yxS911Shhkxo6nzmIxxlSwcN7xEmtHFkmaEdN07LyI5DO/sLT/6877JsRcc2z4MJ29HMvawSa0TyshFTnIngKmwmXZNNe+rfwBpTcnSYCQLK8mHRJ5X6jrqiatURaZQze90Ftyq7+t5xIztfL+hRrz7o+4vcpGT3A5EXPuneJ+jD+73bnUupyxiF0zG5xH16fg4+a19r+41Lpo0LHhylV9Yk/5VK/oZdTbVVD7tpx9xkdvhGw5nwXsommMw+CTNqPLE2Ae4QG6hsl7HfTGO4mHmEg0p9QDqIprZ0VzxXEJhbWKNC+ewXBIMsrV592/I8pLPljf66ukHPmieryVttuvQa1Ymi49ZKBacyzrDIuIzahDAVuUhBwtWZ8iN5TBm269j3svwhlspwzccn1FbjbTXnpjEJge5Es8y1MK9JxmfTxgH2ekFGmZMrIFPMnjV4tOZD0cYHJ9bcB9IJhg5sYhJbHKQKwokEeXDfJbblry0t1z8LSJnn3CAk9v6x4QOsCFlQ/01g90xPFiOAGH4v2ahC+FvmI1t+HMad4LfiCz59xz3OWW81dAN9ff8f1OQb9Ock7COAAAAAElFTkSuQmCC`;
const logoTwitter = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABJNJREFUWAnFV01oXFUUvufOb9IkZSban8FJTDODouhCEASpGBeCXdi6aBVUpJsuXLgQXAkFC+60K6noRlEKtQu1gousFFvQYimIWoSZpMmMndZkMrZRp/OTedfve4+XeW/m9SUtKXNheOece+75zj333HPuiNrkMMbEi+XajLLM86LUQ1iWMaIyXC5GVfCpGKUuKS3f5LLp70SkxbmNBmyFj8tL/+5aqzeOAuZlpcyYVxuLG+QBnPTKobsK6cnocPLY1I6Ra/45P3dLB7DjxFy59ja+bwJhG4y2RBR3dgaAZxMSqWSz22s0Vy7fSDdNJwNje6G/3xg1AwfiStR/0D8+nU2/i2/TD+1wgQ44u25+BSNPALittfnYxBPHcrtGl4KM9MqK1/7ZIa3mUcuSI7ARg42fosOJF4Ki0efAfLn2aMcy3ypj7sOOL4qOvTSd3V7oBdkMP1e+kTdW+xQi8pgS+VNr2Ydo/Opd63PA3vnN5s8OuJwejqUPZzJS9y64XbpSMcP1du0THM0hOhEdSjweFAlgmkRhYeXHwkLVFBdXvgDvc+52gb36tEWbtE0MYrnz2iWYcDxzhp07R9Ig17Zm0JZjU10khoPl2LZ36YS+UVRG4joSffhOz3wjd5kTVmftdxSOVnQomeNR2BGw7zmuGrP9TsF51hsdG20Tg9faqS24H1gUx/lUQSYkGc8GXTV6rkes5alU6nrvLucrf09abesk7DwJG6tKq3e0kquWknp+InWmV59X1DRaZcgbucn0vdour0qNssgEgdOAsTrPdFatH+avrD7Qa9Bqd750wG3NMZTq9y3L+gg729mrS97GEPU9rI4RW7O2cwKJ0uct5RyiTBIgj3TWWheKi9XXQEcpL5WuT9t3nIxnILFiEW394hH5SC3ytS0AtoYyGwvr+VmfloeRZOIUIlSH0ggAP50r1ZYKi9XPUX5f9ah1SVGzU9l7zncFfsrFIjZ3Ync01na/WpczzeY+cFfwy1OKCKTwecV2m4K+IQt9Io+AWA1lUZLRbKnwpOE2Fo/eOgnVCnZug68LQwgk4YWQaUUsYhJ7vRCFLchPjM+KlvfCdLpz0h6Kx2a7fAhllNF8TOBMkmypIaq4r0hS1PIwHXtOq8927x5dDtMjFjERhauMgH327Odhi/ZMpM7D2d/CdDC3HEkkUNLDhwerouHJJarDm71hy3BN27n7x58TJW8F6fFMo5HIwT07R/4KmvfKXCxiR/mGQy14HZm9H0ofehVder608qxlzINGyVOQHeCd9Q1RFVH6xals6pxPfgsGtg7YU8DWfECyhCLLZ1gmg9aYqPwBTN6W9UqIunATUTmH7xvbYuP56cn0psBtDKOeJqaDDUT06RPs1XOl6gdBDnhliFTssrEr46ZukHctaWI474LqCfLYlFIDb8fsywjncVS2GN9wbK10bCuH3a5hmxjE6nuWIbR39UlWWFw5Hfokg1dNPp1ZbODMITScLYkEd05baCAH7UcpMIjlRtfOAZfhd6DPcteRgf4xcZ1gTgzsr5nrBL9ONAbw59TrBGlE5K78Pf8f0d6osaYZoJYAAAAASUVORK5CYII=`;


const App = () =>  {


  const [user, setUser] = useState(false);
  const security = useRef( JSON.parse(localStorage.getItem("userBulletin")) ).current;

  // Get user data by url
  const getUserDataFromUrl = useCallback(() => {
  }, []);

  useEffect(() => {
    // Hide charging view
  }, []);

  return (
    <Router exact path="/" >
      <Header />

      <Switch>
        {/* Main Page */}

        <Route exact path="/">
          <Main />
        </Route>

        {/* Modules */}
        <Route path='/'>
          <Bulletin user={user} security={security} />
        </Route>

        <Route path='/recursos/notas/'>
          <Bulletin user={user} security={security} />
        </Route>

        <Route path="/services/boletin/unsubscribe/">
          <Unsubscribe />
        </Route> 

        {/* Page not found (Error 404) */}
        <Route path='404'>
          <NotFound />
        </Route>
        {/* Page not found (Redirect to Main) */}
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>

      <Footer />
    </Router>
  );
}

{/* Main Modular Components */}
const Bulletin = (props) => {
  /* To keep good practices 'history' should be declared in each module */

  const history = useRef(useHistory()).current;
  const redirect_data = useRef({});

  const redirectTo = useCallback((url, _redirect_data) => {
    redirect_data.current = _redirect_data;  // Save redirect data
    history.push(url);
  }, []);

  return (
    <div className="container page-body">
      <Switch>

        {/* Bulletin Main Page && list of bulletins */}
        <Route exact path="/">
          <MainBulletin />
        </Route>

        {/* Information 'bout bulletin && list of resources */}
        <Route exact path="/:boletin/">
          <BulletinPrincipal
            history={history}
            notFound={(data) => redirectTo("/notfound", data)}
            />
        </Route>

                {/* Selected resource */}
        <Route exact path="/:boletin/:title/">
          <ResourceDetail
            user={props.user}
            security={props.security}
            history={history}
            notFound={(data) => redirectTo("/resourcenotfound/", data)}
            />
        </Route>

        <Route exact path="/services/boletin/unsubscribe/:email">
          <Unsubscribe
            history={history}
            notFound={(data) => redirectTo("/notfound", data)}
            />
        </Route>

        {/* Error handling */}
        <Route exact path="/notfound/">
          <NotFoundBulletin data={redirect_data.current} />
        </Route>
        <Route exact path="/resourcenotfound/">
          <NotFoundResource data={redirect_data} />
        </Route>
        {/* FIN Error handling*/}

      {/* Selected resource */}
      <Route exact path="/recursos/notas/:title/">
        <ResourceDetail
          user={props.user}
          security={props.security}
          history={history}
          tipo={"portal"}
          notFound={(data) => redirectTo("/resourcenotfound/", data)}
          />
      </Route>

      </Switch>
    </div>
  );
}

{/* Main Page Components */}
const Main = () => {
  loadingPrincipal(false);
  return (
    <Listado></Listado>
  );
}
const MainBulletin = () => {
  loadingPrincipal(false);
  return (
    <Listado></Listado>
  );
}
const BulletinPrincipal = (props) => {

  // General variables declaration
  const boletin_id = useRef(useParams().boletin).current;
  // Component states
  const [resource, setResource] = useState(false);
  const [section, setSection] = useState([]);
  const [css_class, setCss_class] = useState('');  // DOM element css class
  const [sector, setSector] = useState([]);  // Sector description

  /* Use useCallback so constant functions are not re-declared each render
  * These constant functions (which do not depends of component state variables)
  * can also be declared outside the functional component
  * but since they are logically part of the "module" we ratter declare 'em inside the component
  */
  const getDescription = useCallback(_key => {
    let _val = "";
    switch(_key){
      case "39": _val = "Multisectorial"; break;
      case "40": _val = "Manufacturas diversas"; break;
      case "41": _val = "Agronegocios"; break;
      case "42": _val = "Productos Pesqueros"; break;
      case "43": _val = "Industria de la vestimenta y decoración"; break;
      case "44": _val = "Exportación de servicios"; break;
      default: break;
    }
    return _val;
  }, []);
  
  const callSections = useCallback(() => {
    const url = `${API_URL}SectionUX/${boletin_id}`;
    axios.get(url).then(response => response.data)
    .then(data => {
      setSection(data.result);
    }).catch(error => {
      console.error(error);
    });
  }, []);

  const renderMenu = useCallback((index, key, description, show, code, orden) => {
    if(show && orden>0){
      return (
        <div>
          <li className="nav-item boletin__nav-item">
            <a className={"nav-link active boletin__nav-link boletin__nav-link" + (index===0?("--active"):("")) +" scroll"} href={"#section_"+code}>
              <strong> {description} </strong>
            </a>
          </li>
        </div>
      );
    } else if (show && orden==0)
    {
      return (
        <div>
          <li className="nav-item boletin__nav-item">
            <a className={"nav-link active boletin__nav-link boletin__nav-link" + (index===0?("--active"):("")) +" scroll"} >
              <strong> {description} </strong>
            </a>
          </li>
        </div>
      );
    }
  }, []);


  const renderSwitch = useCallback((param, show, title, clase) => {
    if(show){
      let _component = [];
      switch(param){
        case 'NVOP':
          _component.push(
            <NuevasOportunidades key={"__"+param} clase={clase} clave={boletin_id} titulo={title} />
          ); break;
        case 'PPMM':
          _component.push(
            <Noticias key={"__"+param} clase={clase} clave={boletin_id} titulo={title} />
          ); break;
          case 'PPRE':
            _component.push(
              <NoticiasOcex key={"__"+param} clase={clase}  className="sgray-bg-semi-dark" clave={boletin_id} titulo={title} />
            ); break;
          case 'ANAM':
          _component.push(
            <AnalisisMercado key={"__"+param} sector={1142} clase={clase} clave={boletin_id} titulo={title} />
          ); break;
        case 'CALE':
          _component.push(
            <Calendario key={"__"+param} sector={9} clave={boletin_id} titulo={title} />
          ); break;
        case 'PART':
          _component.push(
            <div key={"__"+param} className="share-info gray-bg-dark"><Compartir clave={boletin_id} /><CompartidoOtros clave={boletin_id} /></div>
          ); break;
        case 'CONS':
          _component.push(
            <Consultorio key={"__"+param} clave={boletin_id} titulo={title} />
          ); break;
        case 'ULSC':
          _component.push(
            <UltimosSucesos key={"__"+param} />
          ); break;
        case 'VVRE':
          _component.push(
            <VistoRedes key={"__"+param} className="sgray-bg-semi-dark" clave={boletin_id} titulo={title} />
          ); break;
        case 'OTSE':
          _component.push(
            <OtrosSectores key={"__"+param} className="sgray-bg-semi-dark" clave={boletin_id} titulo={title} />
          ); break;
        
        default: return '';
      }
      return _component;
    }
  }, []);

  useEffect(() => {

    loadingPrincipal(true);  // Show charging view

    const url = `${API_URL}BulletinUX/${boletin_id}/0`;
    axios.get(url).then(response => response.data)
    .then((data) => {
      if(data.result.nBoletinCodigo===0){  // Error 404 Not Found
        // Redirect to 404 Bulletin Page
        props.notFound({message: "El boletín no fue encontrado"});
        return;
      }

      callSections();  // Get bulletin sections
      setResource(data.result);  // Set resource

      var titulo =data.result.sTitulo;
      var id =data.result.nBoletinCodigo;

      document.title = titulo + ' ' + id;

    }).catch(error => {
      console.log(error)
      props.notFound(error);  // Redirect to 404 Bulletin Page
    });
  }, []);
  
  useEffect(() => {
    if(!resource) return;
    // When resource has already charged and component has been rendered

    // Hide charging view
    loadingPrincipal(false);

    // Set background image
    if(document.getElementById("imageBack")!==null){
      /*document.getElementById("imageBack").style.backgroundImage = "url('"+
        (resource.sFondo&&resource.sFondo.indexOf("boletin/")!=-1
          ? BASE_URL_RECURSOS+resource.sFondo
          : resource.sFondo )
      +"')";*/
      if(resource.sFondo != null){
        document.getElementById("imageBack").style.backgroundImage = "url('" + ( BASE_URL_RECURSOS+resource.sFondo ) +"')";
      }
      document.getElementById("imageBack").style.backgroundRepeat = "no-repeat";
      document.getElementById("imageBack").style.backgroundSize = "cover";
      document.getElementById("imageBack").style.backgroundPosition = "center";
    }

    // Set sector && css_class
    let keySector = resource.nSectorCodigo.toString();
    let sectorDescription = getDescription(keySector);

    let css_class = 'verde';
    switch(keySector){
      case "39": css_class = "azul"; break;
      case "40": css_class = "amarillo"; break;
      case "41": css_class = "verde"; break;
      case "42": css_class = "azul-light"; break;
      case "43": css_class = "morado"; break;
      case "44": css_class = "marron"; break;
      case "1085": css_class = "azul"; break;
      default:  css_class = "verde"; break; 
      break;
    }

    console.log('function=' +css_class );

    setSector(sectorDescription);
    setCss_class(css_class);

  }, [resource]);

  
Moment.updateLocale('en', {
  months : [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
      "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
  ]
});
Moment.updateLocale('en', {
  weekdays : [
      "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
  ]
});
 
  document.title=resource.sTitulo;
  
  return (
    <div className="main">
      <div className="l_section gray-bg-semilight boletin__category--mobile">
        <div className="boletin__section">
          <div className="row boletin__subheader">
            <div className="col-sm-12">
              <ul id="boletin__header-title">
                {/* <li className="boletin__category">
                  <span hidden={true} className="boletin__category--pl"><strong>Boletín de inteligencia</strong></span>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="l_section red-bg" hidden={(resource.cEstado==="A")}>
        <div className="col-sm-12 boletin__title-name-section">
          <span className="last-news__title">¡Advertencia!, este boletín aún no se encuentra aprobado.</span>
        </div>
      </div>
      <div className="l_section gray-bg">
        <div className="boletin__section boletin__section--date">
          <div className="row">
            <div className="col-sm-4">
              <p className="boletin__sector-section">
                <img alt="" src={"/img/"+resource.sClaveSector+".png"} />
                <span className={"boletin__sector sector-"+css_class+"--bg-color" }>{sector} </span>
              </p>
            </div>
            <div className="col-sm-5 boletin__title-name-section">
            <span style={ {fontSize: 20}} className={"boletin__title-name boletin__title-name--"+css_class}> {resource.sTitulo}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="l_section gray-bg">
        <div className="boletin__section white-bg boletin__links-section">
          <ul className="nav nav-fill">
          {section.map((section, index) => (
            <div key={section.nSeccionCodigo}>
              { renderMenu(index, section.nSeccionCodigo, section.sTitulo, section.bIsAdded, section.sCodigo, section.bOrden)}
            </div>
          ))}
          </ul>
        </div>
      </div>

      <div className="last-news" id="imageBack">
        <Principal clase={css_class} clave={boletin_id}></Principal>
      </div>


      {section.map((section, index) => (
        <div key={section.nSeccionCodigo} id={"section_" + section.sCodigo}>
          {renderSwitch(section.sCodigo, section.bIsAdded, section.sTitulo, css_class)}
        </div>
      ))}
      <div className="dark-bg" id="">
        <div className="boletin__section footer__section">
          <div className="row align-items-center">
          <div className="col-sm-8">
              <p className="last-news-sector__secundary-item-title">
                <b>Contáctanos:</b> 
              </p>
              <p className="footer__address">
                exportaciones@promperu.gob.pe
              </p>
              {/* <p className="footer__address">
              correo@promperu.gob.pe
              </p> */}
          </div>
          <div className="last-news-sector__secundary-item-title">
            &nbsp; &nbsp;&nbsp;  Síguenos en  &nbsp;&nbsp;  <a target="_blank" href="https://www.facebook.com/promperu"> <img src={logoFacebook} /> </a>&nbsp;&nbsp;  <a target="_blank" href="https://twitter.com/promperu"><img src={logoTwitter} /></a> &nbsp;&nbsp;  <a target="_blank" href="https://www.youtube.com/promperu" ><img src={logoYoutube} /> </a>&nbsp;&nbsp; 
          </div>
          </div>
        </div>
      </div>

    </div>
  );
}

const ListBulletin = () => {
  return (
    ""
  );
} /**/

// Error handling
const NotFoundResource = (props) => {
  console.error("Error data", props);
  loadingPrincipal(false);
  return (
    ""
  );
}
const NotFoundBulletin = (props) => {
  console.error("Error data", props);
  loadingPrincipal(false);
  return (
    ""
    );
}

export default App;
